import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getArts } from "../../../../actions/arts";
import {
  getNovedadesPrestadorConectividad,
  postNovedadesPrestadorConectividad
} from "../../../../actions/connectivity";
import { clearAllProviders } from "../../../../actions/providers";
import { convertDateTimeToNet } from "../../../../utils/datetimeUtils";
import snackbarUtils from "../../../../utils/snackbarUtils";
import NovedadesPrestadorSearchForm from "./novedadesPrestadorSearchForm";
import NovedadesPrestadorTable from "./novedadesPrestadorTable";

const NovedadesPrestadorSearchContainer = () => {
  const dispatch = useDispatch();
  const providers = useSelector((state) => state.providers.allProvidersOptions);
  const postNovedadesPrestadorConectividadState = useSelector(
    (state) => state.connectivity.postNovedadesPrestadorConectividad,
  );

  const art = useSelector((state) => state.arts);

  const novedadesPrestadorConectividad = useSelector(
    (state) => state.connectivity.novedadesPrestadorConectividad,
  );
  const loading = art.isFetching;
  const tableLoading =
    novedadesPrestadorConectividad.isFetching || postNovedadesPrestadorConectividadState.isFetching;

  const [filters, setFilters] = useState(null);


  useEffect(() => {
    dispatch(clearAllProviders());
    dispatch(getArts());
    return () => {
      dispatch(clearAllProviders());
    }
  }, [dispatch]);

  const handleSubmitSelected = (selectedRows) => {
    const body = {
      ProviderNewsIds: selectedRows.map((row) => row.idTemporalNovedad),
      wriId: filters?.art,
      NewsType: filters?.comportamientoNovedad,
    }
    dispatch(postNovedadesPrestadorConectividad(body)).then(() => {
      snackbarUtils.success("Novedades reenviadas correctamente");
    })
  };

  const handleSubmitSearch = (values) => {
    const queryParams = {
      wriId: values.art,
      dateFrom: convertDateTimeToNet(values.startDate),
      dateTo: convertDateTimeToNet(values.endDate),
      document: values.dni,
      newsType: values.comportamientoNovedad,
      providerId: values.providerId,
    };
    dispatch(getNovedadesPrestadorConectividad(queryParams));
    setFilters(values);
  };

  return (
    <>
      <NovedadesPrestadorSearchForm
        loading={loading}
        providers={providers.data}
        arts={art.list}
        model={filters}
        handleSubmitSearch={handleSubmitSearch}
      />
      <NovedadesPrestadorTable
        loading={tableLoading}
        namesArts={art.namesArts}
        handleSubmitSelected={handleSubmitSelected}
        data={novedadesPrestadorConectividad.data}
      />

    </>
  );
};

export default NovedadesPrestadorSearchContainer;
